import dispatcher from "./dispatcher.component";
import dispatcherUrls from "./dispatcher.urls";
import DispatcherTransforms from "./dispatcher.transforms";

const dispatcherModule = angular
  .module("app.components.dispatcher", [])
  .component("dispatcherPage", dispatcher)
  .service("DispatcherTransforms", DispatcherTransforms)
  .config(dispatcherUrls);

export default dispatcherModule;



// WEBPACK FOOTER //
// ./src/pages/dispatcher/dispatcher.module.js